import { m as Ct } from "./module.esm-sliwbd8s.js";
import { a as Ze, m as it } from "./morphNodes-DP-Jfkiq.js";
import { q as Qe } from "./queueBounce-D3lri9k8.js";
const tn = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, Te = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, en = (t) => (
  // biome-ignore lint/suspicious/noExplicitAny: Not yet typed
  t.data("addressSwitch", ({ addresses: e }) => ({
    addresses: e,
    slideTransition: Te,
    visibleForm: !1,
    currentlyEditedAddress: null,
    showForm() {
      this.visibleForm = !0;
    },
    editAddress(n) {
      this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find(
        // biome-ignore lint/suspicious/noExplicitAny: Not yet typed
        (r) => r.id === n
      ), this.scrollFormIntoView();
    },
    cancelEdit() {
      this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
    },
    scrollFormIntoView() {
      window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
    }
  }))
), nn = (t) => (
  // biome-ignore lint/suspicious/noExplicitAny: Not yet Typed
  t.data("announcement", (e) => {
    const { settings: n } = e;
    return {
      current: 0,
      init() {
        n.auto_scroll && e.count > 0 && this.autoScroll(), this.$watch("current", (r) => this.autoScroll(r));
      },
      change(r) {
        this.current = r;
      },
      autoScroll(r = 0) {
        r >= e.count ? r = 0 : r += 1, setTimeout(() => this.change(r), n.delay * 1e3);
      },
      scrollThrough() {
        return {
          "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
          "x-transition:enter-start": "-translate-y-full opacity-0",
          "x-transition:enter-end": "translate-y-0",
          "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
          "x-transition:leave-start": "translate-y-0",
          "x-transition:leave-end": "translate-y-full opacity-0 "
        };
      }
    };
  })
), rn = (t) => {
  t.data("backInStock", (e, n) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: n,
      product: e,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const r = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", i = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const o = await fetch(r, i);
        if (!o.ok) throw new Error("Failed to subscribe");
        if (!(await o.json()).success) throw new Error("Failed to subscribe");
      } catch (o) {
        console.error(o);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, on = (t) => {
  const e = {
    id: Number(t.get("id")),
    quantity: Number(t.get("quantity") ?? 1),
    properties: {}
  };
  for (const [n, r] of t.entries())
    if (n === "selling_plan" && r && (e.selling_plan = Number(r)), n.startsWith("properties")) {
      const i = n.match(/\[(.*)\]/)?.[1];
      i && (e.properties[i] = String(r).replace("Offset ", ""));
    }
  return e;
};
var Q = /* @__PURE__ */ ((t) => (t.ADD = "cart/add.js", t.CHANGE = "cart/change.js", t.CLEAR = "cart/clear.js", t.UPDATE = "cart/update.js", t.GET = "cart.js", t))(Q || {});
const qt = (t, e) => e instanceof t ? e : null, sn = (t, e, n = 0) => Math.min(Math.max(t, n), e), dt = {}, an = async (t) => {
  const e = t.toString();
  if (dt[e]) return dt[e];
  const n = await fetch(t);
  return n.ok ? (dt[e] = await n.text(), dt[e]) : null;
}, cn = () => new Promise((t) => queueMicrotask(() => setTimeout(t, 0))), ln = (t, e, n = 0) => (t - n) % (e - n) + n;
class Ot {
  val;
  constructor(e) {
    this.val = e;
  }
  isSome() {
    return !0;
  }
  isNone() {
    return !1;
  }
  unwrap() {
    return this.val;
  }
  unwrapOr(e) {
    return this.val;
  }
  unwrapOrElse(e) {
    return this.val;
  }
  expect(e) {
    return this.val;
  }
  andThen(e) {
    return e(this.val);
  }
  orElse() {
    return this;
  }
  map(e) {
    return new Ot(e(this.val));
  }
  mapOr(e, n) {
    return e(this.val);
  }
  mapOrElse(e, n) {
    return e(this.val);
  }
  flatten() {
    return un(this.val) ? this.val : this;
  }
  inspect(e) {
    return e === 2 ? this : (e(this.val), this);
  }
  okOr(e) {
    return new lt(this.val);
  }
}
let Ce = class {
  val = null;
  isSome() {
    return !1;
  }
  isNone() {
    return !0;
  }
  unwrap() {
    throw new Error("called `Option.unwrap()` on a `None` value");
  }
  unwrapOr(e) {
    return e;
  }
  unwrapOrElse(e) {
    return e();
  }
  expect(e) {
    throw new Error(`Error unwrapping None. Expected ${e}`);
  }
  andThen() {
    return this;
  }
  orElse(e) {
    return e();
  }
  map(e) {
    return this;
  }
  mapOr(e, n) {
    return n;
  }
  mapOrElse(e, n) {
    return n();
  }
  flatten() {
    return this;
  }
  inspect() {
    return this;
  }
  okOr(e) {
    return new X(e);
  }
};
const un = (t) => t instanceof Ot || t instanceof Ce, dn = new Ce(), fn = /* @__PURE__ */ Symbol(), hn = /* @__PURE__ */ Symbol();
class lt {
  is = fn;
  value;
  constructor(e) {
    this.value = e;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !1;
  }
  unwrap() {
    return this.value;
  }
  unwrapOr(e) {
    return this.value;
  }
  unwrapOrElse(e) {
    return this.value;
  }
  unwrapErr() {
    throw new Error("called `Result.unwrapErr()` on an `Ok` value");
  }
  expect(e) {
    return this.value;
  }
  andThen(e) {
    return e(this.value);
  }
  orElse() {
    return this;
  }
  map(e) {
    return new lt(e(this.value));
  }
  mapErr() {
    return this;
  }
  mapOr(e, n) {
    return e(this.value);
  }
  mapOrElse(e, n) {
    return e(this.value);
  }
  inspect(e) {
    return e === 2 ? this.value : (e(this.value), this);
  }
  inspectErr() {
    return this;
  }
  ok() {
    return new Ot(this.value);
  }
  flatten() {
    const e = this.value;
    return pn(e) ? e : this;
  }
}
class X {
  is = hn;
  error;
  constructor(e) {
    this.error = e;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !0;
  }
  unwrap() {
    throw this.error;
  }
  unwrapOr(e) {
    return e;
  }
  unwrapOrElse(e) {
    return e(this.error);
  }
  unwrapErr() {
    return this.error;
  }
  expect(e) {
    throw new Error(`Error unwrapping Err value: ${this.error}. Expected ${e}`);
  }
  andThen() {
    return this;
  }
  orElse(e) {
    return e(this.error);
  }
  map() {
    return this;
  }
  mapErr(e) {
    return new X(e(this.error));
  }
  mapOr(e, n) {
    return n;
  }
  mapOrElse(e, n) {
    return n(this.error);
  }
  inspect(e) {
    return e === 2 ? this.error : this;
  }
  inspectErr(e) {
    return e(this.error), this;
  }
  ok() {
    return dn;
  }
  flatten() {
    return this;
  }
}
const pn = (t) => t instanceof lt || t instanceof X;
class Ut extends Error {
  constructor(e) {
    super(e.message, { cause: e }), this.retry = !1, this.fullPull = !1, e.status === 422 && (this.fullPull = !0);
  }
}
var Oe = /* @__PURE__ */ ((t) => (t[t.Unknown = 0] = "Unknown", t[t.VariantNotFound = 404] = "VariantNotFound", t[t.UnprocessableEntity = 422] = "UnprocessableEntity", t))(Oe || {});
async function kt(t, e) {
  const n = new URL(
    window.Shopify.routes.root + t,
    window.location.origin
  );
  try {
    const r = await fetch(n, {
      method: t === Q.GET ? "GET" : "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: e ? JSON.stringify(e) : void 0
    });
    if (!r.ok) return new X(new Ut(await r.json()));
    const i = await r.json();
    return new lt(i);
  } catch (r) {
    return new X(
      new Ut({
        status: Oe.Unknown,
        message: "An Unknown error Occured with a request to Shopify",
        description: r instanceof Error ? r.message : `Sending a request to ${t} with payload ${e} failed.`
      })
    );
  }
}
const zt = (t) => {
  const e = mn(t);
  return kt(Q.ADD, e);
}, mn = (t) => ({
  items: Ze(t).map((n) => typeof n == "object" ? {
    quantity: 1,
    ...n,
    properties: Object.assign({}, n.properties ?? {})
  } : { id: n, quantity: 1, properties: {} })
}), gn = (t) => kt(Q.CHANGE, t), vn = () => kt(Q.GET), bn = (t) => {
  const e = {
    updates: t
  };
  return kt(Q.UPDATE, e);
}, yn = (t) => {
  let e = 0;
  const n = new EventTarget();
  t.store("cart", {
    name: "cart",
    section: "cart-drawer",
    isOpen: new URLSearchParams(location.search).get("cart") === "true",
    updating: !0,
    data: JSON.parse(
      document.querySelector("script#cart-data")?.textContent ?? "{}"
    ),
    items: [],
    get totalItems() {
      return this.items.reduce(
        (r, i) => r + i.quantity,
        0
      );
    },
    get totalPrice() {
      return this.data.total_price;
    },
    init() {
      this.items = this.data.items, window.addEventListener("rebuy.beforeAdd", () => this.updating = !0), window.addEventListener(
        "rebuy.add",
        () => this.update(async () => this.data = await this.getState())
      ), n.dispatchEvent(new Event("init")), this.updating = !1;
    },
    async update(r) {
      n.dispatchEvent(new Event("update"));
      try {
        this.updating = !0, e++;
        const i = await r();
        return e && e--, e || (this.updating = !1, t.nextTick(() => this.items = this.data.items)), i;
      } catch (i) {
        return console.error(i), this.data = await this.getState(), this.updating = !1, t.nextTick(() => {
          this.items = this.data.items;
        }), this.data;
      }
    },
    toggle() {
      this.isOpen ? this.open() : this.close();
    },
    open() {
      this.isOpen || (this.isOpen = !0, n.dispatchEvent(new Event("open")));
    },
    close() {
      this.isOpen && (this.isOpen = !1, n.dispatchEvent(new Event("close")));
    },
    load() {
      n.dispatchEvent(new Event("load"));
    },
    handleError(r) {
      n.dispatchEvent(
        new CustomEvent("error", { detail: r.cause.message })
      );
    },
    async getState() {
      const r = (await vn()).inspectErr(this.handleError).unwrapOr(this.data);
      return queueMicrotask(this.load), r;
    },
    async addItem(r) {
      await this.update(async () => {
        (await zt(r)).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async removeItem(r) {
      await this.update(async () => {
        (await bn({ [r]: 0 })).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async updateItem(r, i) {
      await this.update(async () => {
        (await gn({ id: r, ...i })).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async addFromForm(r) {
      await this.update(async () => {
        const i = r instanceof HTMLFormElement ? [r] : document.querySelectorAll(
          (r.startsWith("form") ? "" : r.startsWith("#") ? "form" : "form#") + r
        );
        try {
          const o = Array.prototype.map.call(i, (s) => (console.assert(s.reportValidity(), "Form is invalid"), on(new FormData(s)))).filter(Boolean);
          (await zt(o)).inspectErr(this.handleError).unwrap(), this.data = await this.getState();
        } catch (o) {
          console.error(o);
        }
      }), this.open(), await this.update(async () => this.data = await this.getState()), t.nextTick(() => this.open());
    },
    addEventListener(r, i) {
      n.addEventListener(r, i);
    },
    removeEventListener(r, i) {
      n.removeEventListener(r, i);
    },
    dispatchEvent(r) {
      return n.dispatchEvent(r);
    }
  });
}, wn = window?.Shopify?.currency ?? { active: "USD" }, Wt = `${window?.Shopify?.locale ?? "en"}-${window?.Shopify?.country ?? "US"}`, J = (t, e = Wt, n = {}) => new Intl.NumberFormat(e || Wt, {
  style: "currency",
  currency: wn.active,
  currencyDisplay: "narrowSymbol",
  ...n
}).format(Number(t)), xn = (t) => t.data("cartDrawer", () => ({
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = t.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh);
  },
  destroy() {
    this.$store.cart.removeEventListener("open", this.refresh);
  },
  async refresh() {
    const e = new URL(window.location.href), n = Ft();
    e.searchParams.set("sections", n.join(","));
    const r = await fetch(e);
    if (n.length) {
      const i = await r.json();
      it(Object.values(i).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async removeItem(e) {
    const n = {
      [e]: 0
    }, r = Ft(), i = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates: n, sections: r.join(",") })
    });
    if (r.length) {
      const o = await i.json();
      it(Object.values(o.sections).join(""), []);
    }
  },
  async updateItem(e, n) {
    const r = {
      [e]: n
    }, i = Ft(), o = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates: r, sections: i.join(",") })
    });
    if (i.length) {
      const s = await o.json();
      it(Object.values(s.sections).join(""), []);
    }
  },
  formatMoney: J
})), Ft = () => {
  const t = Array.from(
    document.querySelectorAll(".shopify-section:has([data-oob-swap])"),
    (n) => n?.id.replace("shopify-section-", "") ?? ""
  );
  return Array.from(new Set(t));
};
function En() {
  return JSON.parse(
    JSON.stringify({
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;"
      }
    })
  );
}
function Sn(t, e) {
  return fetch(t, e).then(function(n) {
    if (!n.ok)
      throw n;
    return n.json();
  });
}
function ke(t) {
  var e = En();
  return e.method = "POST", e.body = JSON.stringify(t), Sn("/cart/update.js", e);
}
function Kt(t) {
  return ke({ attributes: t });
}
function ft(t) {
  return ke({ note: t });
}
const Tn = (t) => {
  t.data(
    "cartOptions",
    (e) => ({
      ...e,
      updateNote: ft,
      showNote: !!e.giftNote,
      isGift: e.isGift === "true",
      giftBox: !1,
      get cart() {
        return this.$store.cart;
      },
      init() {
        this.giftBox = !!this.boxLineItem, this.$watch("boxLineItem", (n) => {
          !!n != this.giftBox && (this.giftBox = !!n);
        }), e.isGift === !0 && !this.showNote && !this.giftBox && Kt({ isGift: "" }).then(() => this.isGift = !1), this.$watch("giftBox", (n) => {
          if (n && !this.boxLineItem)
            this.$store.cart.addItem(this.productId).then((r) => this.boxLineItem = r);
          else {
            const r = this.boxLineItem.key;
            this.$store.cart.removeItem(r);
          }
        }), this.$watch("isGift", (n) => {
          Kt({ isGift: n }), n || (this.giftBox = !1, this.showNote = !1, ft(""), this.giftNote = "");
        }), this.$watch("showNote", (n) => {
          n || (ft(""), this.giftNote = "");
        });
      },
      get cartItems() {
        return this.$store.cart.data.items;
      },
      get boxLineItem() {
        return this.cartItems?.find((n) => n.id === this.productId);
      },
      get showOptions() {
        return this.isGift;
      },
      postNote() {
        ft(this.giftNote);
      }
    })
  );
}, Cn = (t) => (
  // biome-ignore lint/suspicious/noExplicitAny: Not yet Typed
  t.data("collectionFilters", (e) => ({
    ...e,
    open: !1,
    fadeTransition: {
      "x-transition:enter": "transition-opacity ease-linear duration-300",
      "x-transition:enter-start": "opacity-0",
      "x-transition:enter-end": "opacity-100",
      "x-transition:leave": "transition-opacity ease-linear duration-300",
      "x-transition:leave-start": "opacity-100",
      "x-transition:leave-end": "opacity-0"
    },
    slideTransition: {
      "x-transition:enter": "transition ease-in-out duration-300 transform",
      "x-transition:enter-start": "-translate-x-full",
      "x-transition:enter-end": "translate-x-0",
      "x-transition:leave": "transition ease-in-out duration-300 transform",
      "x-transition:leave-start": "translate-x-0",
      "x-transition:leave-end": "-translate-x-full"
    }
  }))
), On = (t) => t.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute(
      "aria-controls",
      this.$refs.contentElement.id
    ), this.theDetails = this.$el, this.$watch(
      "$store.mobileMenu.visible",
      (e) => !e && this.close()
    );
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), kn = (t) => t == null ? [] : Array.isArray(t) ? t.map((e) => Number(e)) : typeof t == "number" && !Number.isNaN(t) ? [t] : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean).map((e) => Number(e)) : [], Nn = (t) => t ? Array.isArray(t) ? t.map(String) : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean) : [] : [], Ln = (t) => t ? typeof t == "string" ? t : String(t) : "", ht = (t) => {
  const e = t ?? {};
  let n = Number(e.cutOffHour);
  Number.isFinite(n) || (n = 14);
  let r = Number(e.leadTime);
  return Number.isFinite(r) || (r = 0), {
    cutOffHour: n,
    leadTime: r,
    messageHtml: Ln(e.messageHtml),
    isCustomMessage: !!e.isCustomMessage,
    restrictedDays: kn(e.restrictedDays),
    restrictedDates: Nn(e.restrictedDates)
  };
}, Gt = (t) => t.dayOfWeek % 7, _n = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], In = (t) => {
  let e = Math.max(0, Math.floor(t));
  const n = Math.floor(e / 86400);
  e %= 86400;
  const r = Math.floor(e / 3600);
  e %= 3600;
  const i = Math.floor(e / 60), o = e % 60;
  return { days: n, hours: r, minutes: i, seconds: o };
}, Rn = (t) => {
  const e = t.dataset.esCfgId;
  if (!e) return ht(void 0);
  const n = document.getElementById(e);
  if (!n?.textContent?.trim()) return ht(void 0);
  try {
    const r = JSON.parse(n.textContent);
    return ht(r);
  } catch {
    return ht(void 0);
  }
}, Dt = "America/Chicago", Fn = (t) => {
  t.data(
    "estimatedShipping",
    (e = {}) => ({
      cutOffHour: 0,
      leadTime: 0,
      messageHtml: "",
      isCustomMessage: !1,
      restrictedDays: [],
      restrictedDates: [],
      message: "",
      intervalId: null,
      async init() {
        "Temporal" in globalThis || await import("./global.esm-WnEKWzHy.js"), Object.assign(this, Rn(this.$el), e), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
      },
      destroy() {
        clearInterval(this.intervalId);
      },
      tick() {
        const n = Temporal.Now.zonedDateTimeISO(Dt), r = this.nextCutoffDate(), i = r.epochNanoseconds - n.epochNanoseconds, o = i <= 0n ? 0 : Number(i / 1000000000n), { days: s, hours: a, minutes: c, seconds: l } = In(o), d = [];
        (d.length || s) && d.push(s === 1 ? `${s} day` : `${s} days`), (d.length || a) && d.push(a === 1 ? `${a} hour` : `${a} hours`), (d.length || c) && d.push(
          c === 1 ? `${c} minute` : `${c} minutes`
        ), (d.length || l) && d.push(
          l === 1 ? `${l} second` : `${l} seconds`
        );
        const u = this.nextShippingDate(r), f = u.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : _n[Gt(u)];
        this.message = String(this.messageHtml).replace("%countdown%", d.join(", ")).replace("%ship_day%", f);
      },
      nextCutoffDate() {
        const n = Temporal.Now.zonedDateTimeISO(Dt);
        let r = Temporal.Now.zonedDateTimeISO(Dt).with({
          hour: this.cutOffHour,
          minute: 0,
          second: 0,
          millisecond: 0
        });
        for (Temporal.ZonedDateTime.compare(r, n) === -1 && (r = r.add({ days: 1 })); this.isDateRestricted(r); )
          r = r.add({ days: 1 });
        return r;
      },
      nextShippingDate(n) {
        let r = n, i = this.leadTime;
        for (; this.isDateRestricted(r) || i > 0; )
          r = r.add({ days: 1 }), this.isDateRestricted(r) || i--;
        return r;
      },
      isDateRestricted(n) {
        if (this.restrictedDays.includes(Gt(n))) return !0;
        const r = n.toPlainDate().toString(), i = r.slice(5);
        return this.restrictedDates.some((o) => o === r || o === i);
      }
    })
  );
}, Dn = (t) => {
  t.data("filterController", (r) => {
    const i = [];
    return r || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await t.nextTick(), this.facetChange(!1), i.push(t.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: o }) {
        this.facetData = o ? JSON.parse(o) : this.facetChange();
        const s = this.facetData;
        document.querySelectorAll(
          "#filter-drawer input[type=checkbox]"
        ).forEach((d) => {
          d.checked = s.some(
            ([u, f]) => u === d.name && f === d.value
          );
        });
        const c = s.find(([d]) => d === "sort_by")?.[1];
        if (!c) return;
        const l = document.querySelector(
          'select[name="sort_by"]'
        );
        l && (l.value = c);
      },
      destroy() {
        i.forEach(t.release);
      },
      _expanded: [!0],
      expanded(o) {
        return this._expanded[o];
      },
      expand(o) {
        this._expanded[o] = !this._expanded[o];
      },
      open: !1,
      fadeTransition: tn,
      slideTransition: Te,
      facetData: [],
      facetChange(o = !0) {
        return this.facetData = Object.values(
          this.forms
        ).flatMap((s) => Array.from(new FormData(s).entries())).filter(
          ([s, a]) => !(s === "sort_by" && a === "manual" || s === "page" && (o || a === "1"))
        ), this.facetData;
      },
      filterProducts() {
        n(this.facetData, r);
      },
      get isFiltered() {
        return this.facetData.some(
          ([o]) => !["type", "sort_by", "q"].includes(o)
        );
      }
    };
  });
  let e = !0;
  const n = Qe(
    async (r, i) => {
      const o = new URL(window.location.href);
      o.search = new URLSearchParams(r).toString();
      const s = await an(o);
      if (!s) return;
      e || it(s, i);
      const a = o.toString() === window.location.href;
      history[e || a ? "replaceState" : "pushState"](JSON.stringify(r), "", o.toString()), e = !1;
    }
  );
}, $n = (t) => {
  t.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, t.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), t.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((e) => e) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, An = (t) => t.data("mobileMenu", () => ({
  size: "70vh",
  adjustSize() {
    const e = this.$refs.menuDrawer;
    if (!e) return;
    const n = e.closest("section > div.relative")?.getBoundingClientRect();
    if (!n) return;
    const r = n.y + n.height;
    this.size = `${r}px`;
  },
  get isOpen() {
    return this.adjustSize(), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((e) => e.removeAttribute("open"));
  }
})), Mn = (t) => t.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (e) => {
      !e && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(e = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, e && this.$store.modal.close();
  }
})), Pn = (t) => t.data("mainProduct", () => ({
  data: Yt(),
  get product() {
    return this.data.product;
  },
  get currentVariant() {
    return this.data.currentVariant;
  },
  get selectedOptions() {
    return this.data.selectedOptions;
  },
  updating: !1,
  adding: !1,
  quantity: 1,
  async addToCart(e) {
    this.adding = !0, await t.store("cart").addFromForm(e), this.adding = !1;
  },
  init() {
    this.$watch("selectedOptions", async (e) => {
      const n = this.getVariantFromOptions(e);
      if (!n) return;
      this.data.currentVariant = n, this.updating = !0;
      const r = new URL(window.location.href);
      r.searchParams.set("variant", n.id.toString()), await Jt(r), n === this.currentVariant && (this.updating = !1);
    }), this.$watch(
      "product",
      () => this.data.currentVariant = this.selectedOrFirstAvailableVariant(this.currentVariant.options) ?? this.data.currentVariant
    );
  },
  get variantDiscount() {
    return this.onSale ? "Save " + J(
      (this.currentVariant.compare_at_price ?? this.currentVariant.price) - this.currentVariant.price
    ) : "";
  },
  formatDate(e) {
    const [n, r, i] = e.split("-").map(Number);
    return `${[
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ][r - 1]} ${i}, ${n}`;
  },
  get compareAtPrice() {
    const e = this.currentVariant.compare_at_price;
    return e ? J(e) : !1;
  },
  get onSale() {
    return (this.currentVariant.compare_at_price ?? 0) > this.currentVariant?.price;
  },
  get variantPrice() {
    return J(this.currentVariant.price);
  },
  get variantAvailable() {
    return this.currentVariant.available;
  },
  get productMeta() {
    return this.currentVariant.available ? this.onSale ? {
      class: "bg-red-400",
      text: "Save money"
    } : !1 : {
      class: "bg-gray-400",
      text: "Sold out"
    };
  },
  getVariantFromOptions(e) {
    return this.product.variants.find(
      (n) => n.options.every((r, i) => r === e[i])
    );
  },
  isOptionAvailable(e, n) {
    const r = [...this.currentVariant.options];
    return r[e] = n, this.getVariantFromOptions(r)?.available ?? !1;
  },
  colorIsActive(e) {
    return e === this.product.id;
  },
  selectedOrFirstAvailableVariant(e) {
    return this.product.variants.find((r) => e.every(
      (i, o) => r.options[o] === i
    )) || this.product.variants.find((r) => r.available);
  },
  setColor(e, n) {
    Object.assign(this, {
      currentColor: e ?? this.currentColor,
      currentGroup: n ?? this.currentGroup
    });
  },
  async changeColor(e, n, r) {
    this.setColor(n, r);
    const i = new URL(e, window.location.href);
    this.updating = !0, await Jt(i), this.data = Yt(), this.updating = !1;
  },
  _hoverColor: "",
  currentColor: "",
  currentGroup: "",
  get colorDisplay() {
    return this._hoverColor || this.currentColor;
  },
  set colorDisplay(e) {
    this._hoverColor = e;
  }
})), Jt = async (t, ...e) => {
  if (t.href !== window.location.href) {
    history.replaceState(null, "", t.href);
    try {
      const n = await fetch(t);
      if (!n) throw new Error("No response");
      const r = await n.text();
      if (window.location.href !== t.href) return;
      it(r, ["main", "title", ...e]);
    } catch (n) {
      console.error(n);
    }
  }
}, Yt = () => JSON.parse(
  document.querySelector("script#product-info")?.textContent ?? "{}"
), Vn = (t) => {
  t.data("productCard", (e) => ({
    variant: e,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: n, description: r, color: i } = this.variant;
      return { name: n, description: r, color: i };
    },
    get colorDisplay() {
      const { name: n } = this.variant;
      return `${n}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(n) {
      Object.assign(this, {
        variant: n
      });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    },
    formatMoney: J
  }));
}, Bn = (t) => {
  t.data("quickOrder", (e) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((n) => n.product_id === e);
    },
    get quantity() {
      return this.productEntries.reduce((n, r) => n + r.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(
        this.productEntries.reduce(
          (n, r) => n + r.final_line_price,
          0
        ) / 100
      );
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: n } of this.productEntries)
        await this.cart.removeItem(n), this.$dispatch("removeall", { id: n });
      this.removing = !1;
    }
  })), t.data("quickOrderRow", (e, n) => ({
    quantity: t.store("cart").items.find((r) => r.id === Number(e))?.quantity ?? 0,
    price: n,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), t.data("quickQuantity", (e) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(n) {
      n = Math.max(0, n), this.q = n;
    }
  }));
}, Hn = (t) => (
  // biome-ignore lint/suspicious/noExplicitAny: Not yet Typed
  t.data("sizes", (e) => ({
    ...e,
    // biome-ignore lint/suspicious/noExplicitAny: Not yet Typed
    changeSize(n) {
      this.$dispatch("product-change", { product: n.product }), history.replaceState(null, n.product.title, n.url);
    }
  }))
), jn = (t) => {
  t.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector(
      "#atc-button button[name=add]"
    ),
    onScroll() {
      if (!this.PDPATC) return;
      const e = this.PDPATC.getBoundingClientRect();
      this.show = e.top < 25;
    }
  }));
}, qn = (t) => t.directive("stickyheader", (e, n, { cleanup: r }) => {
  const i = e.closest("section");
  if (!i || !("Animation" in globalThis)) return;
  const o = new Animation(
    new KeyframeEffect(
      i,
      [
        { top: "0px" },
        {
          get top() {
            return `-${e.clientHeight}px`;
          }
        }
      ],
      { duration: 500, fill: "both" }
    )
  );
  o.persist(), o.reverse(), o.finish();
  const s = t.effect(() => {
    const a = +(t.$scroll.direction === "down" && !t.$scroll.nearTop && !t.store("search").isOpen);
    o.playbackRate = a * 2 - 1;
  });
  r(() => t.release(s));
}), Un = (t) => (
  // biome-ignore lint/suspicious/noExplicitAny: Not yet Typed
  t.data("video", (e) => ({
    ...e,
    videoInit: !1,
    modalContent: null,
    iframe: null,
    player: void 0,
    modalHtml: null,
    video: null,
    play() {
      this.videoInit ? this.startVideo() : this.setupVideo().then(() => this.startVideo());
    },
    setupVideo() {
      return new Promise((n) => {
        this.videoInit = !0, t.nextTick(() => {
          this.video = document.querySelector(`#${this.videoId}`), n();
        });
      });
    },
    pause() {
      this.video.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "pauseVideo", args: "" }),
        "*"
      );
    },
    startVideo() {
      this.video.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "playVideo", args: "" }),
        "*"
      );
    },
    close() {
      this.open = !1;
    },
    events: {
      "x-on:nt:modal-open"() {
        this.play();
      },
      "x-on:nt:modal-close"() {
        this.video && this.pause();
      }
    }
  }))
), zn = (t) => (
  // biome-ignore lint/suspicious/noExplicitAny: Not yet Typed
  t.data("videoBanner", (e) => ({
    open: !1,
    async init() {
      await t.nextTick();
      const n = new window.Vimeo.Player(
        document.querySelector("#" + e.videoEl)
      );
      n.setCurrentTime(0), n.pause(), this.$watch("open", (r) => {
        r && n.play(), n && !r && n.pause();
      });
    }
  }))
), Wn = [
  en,
  nn,
  Fn,
  rn,
  xn,
  Tn,
  Cn,
  On,
  Dn,
  $n,
  An,
  Mn,
  Pn,
  Vn,
  Bn,
  Hn,
  jn,
  qn,
  Un,
  zn
];
var yt = Math.min, U = Math.max, wt = Math.round, pt = Math.floor, H = (t) => ({
  x: t,
  y: t
}), Kn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Gn = {
  start: "end",
  end: "start"
};
function Xt(t, e, n) {
  return U(t, yt(e, n));
}
function Nt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function z(t) {
  return t.split("-")[0];
}
function Lt(t) {
  return t.split("-")[1];
}
function Ne(t) {
  return t === "x" ? "y" : "x";
}
function Le(t) {
  return t === "y" ? "height" : "width";
}
function _t(t) {
  return ["top", "bottom"].includes(z(t)) ? "y" : "x";
}
function _e(t) {
  return Ne(_t(t));
}
function Jn(t, e, n) {
  n === void 0 && (n = !1);
  const r = Lt(t), i = _e(t), o = Le(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (s = xt(s)), [s, xt(s)];
}
function Yn(t) {
  const e = xt(t);
  return [$t(t), e, $t(e)];
}
function $t(t) {
  return t.replace(/start|end/g, (e) => Gn[e]);
}
function Xn(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? o : s;
    default:
      return [];
  }
}
function Zn(t, e, n, r) {
  const i = Lt(t);
  let o = Xn(z(t), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), e && (o = o.concat(o.map($t)))), o;
}
function xt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Kn[e]);
}
function Qn(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function tr(t) {
  return typeof t != "number" ? Qn(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Et(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function Zt(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = _t(e), s = _e(e), a = Le(s), c = z(e), l = o === "y", d = r.x + r.width / 2 - i.width / 2, u = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Lt(e)) {
    case "start":
      p[s] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && l ? -1 : 1);
      break;
  }
  return p;
}
var er = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: d,
    y: u
  } = Zt(l, r, c), f = r, p = {}, v = 0;
  for (let b = 0; b < a.length; b++) {
    const {
      name: g,
      fn: y
    } = a[b], {
      x: E,
      y: S,
      data: N,
      reset: x
    } = await y({
      x: d,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: p,
      rects: l,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (d = E ?? d, u = S ?? u, p = {
      ...p,
      [g]: {
        ...p[g],
        ...N
      }
    }, x && v <= 50) {
      v++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await s.getElementRects({
        reference: t,
        floating: e,
        strategy: i
      }) : x.rects), {
        x: d,
        y: u
      } = Zt(l, f, c)), b = -1;
      continue;
    }
  }
  return {
    x: d,
    y: u,
    placement: f,
    strategy: i,
    middlewareData: p
  };
};
async function Ie(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = Nt(e, t), v = tr(p), g = a[f ? u === "floating" ? "reference" : "floating" : u], y = Et(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(g))) == null || n ? g : g.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), E = u === "floating" ? {
    ...s.floating,
    x: r,
    y: i
  } : s.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), N = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Et(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: E,
    offsetParent: S,
    strategy: c
  }) : E);
  return {
    top: (y.top - x.top + v.top) / N.y,
    bottom: (x.bottom - y.bottom + v.bottom) / N.y,
    left: (y.left - x.left + v.left) / N.x,
    right: (x.right - y.right + v.right) / N.x
  };
}
var nr = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: l
      } = e, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: b = !0,
        ...g
      } = Nt(t, e);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const y = z(i), E = z(a) === a, S = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), N = f || (E || !b ? [xt(a)] : Yn(a));
      !f && v !== "none" && N.push(...Zn(a, b, v, S));
      const x = [a, ...N], m = await Ie(e, g), h = [];
      let w = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (d && h.push(m[y]), u) {
        const L = Jn(i, s, S);
        h.push(m[L[0]], m[L[1]]);
      }
      if (w = [...w, {
        placement: i,
        overflows: h
      }], !h.every((L) => L <= 0)) {
        var C, T;
        const L = (((C = o.flip) == null ? void 0 : C.index) || 0) + 1, F = x[L];
        if (F)
          return {
            data: {
              index: L,
              overflows: w
            },
            reset: {
              placement: F
            }
          };
        let D = (T = w.filter((V) => V.overflows[0] <= 0).sort((V, B) => V.overflows[1] - B.overflows[1])[0]) == null ? void 0 : T.placement;
        if (!D)
          switch (p) {
            case "bestFit": {
              var O;
              const V = (O = w.map((B) => [B.placement, B.overflows.filter((A) => A > 0).reduce((A, tt) => A + tt, 0)]).sort((B, A) => B[1] - A[1])[0]) == null ? void 0 : O[0];
              V && (D = V);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (i !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
async function rr(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = z(n), a = Lt(n), c = _t(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, d = o && c ? -1 : 1, u = Nt(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: v
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return a && typeof v == "number" && (p = a === "end" ? v * -1 : v), c ? {
    x: p * d,
    y: f * l
  } : {
    x: f * l,
    y: p * d
  };
}
var ir = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r
      } = e, i = await rr(e, t);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, or = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (g) => {
            let {
              x: y,
              y: E
            } = g;
            return {
              x: y,
              y: E
            };
          }
        },
        ...c
      } = Nt(t, e), l = {
        x: n,
        y: r
      }, d = await Ie(e, c), u = _t(z(i)), f = Ne(u);
      let p = l[f], v = l[u];
      if (o) {
        const g = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", E = p + d[g], S = p - d[y];
        p = Xt(E, p, S);
      }
      if (s) {
        const g = u === "y" ? "top" : "left", y = u === "y" ? "bottom" : "right", E = v + d[g], S = v - d[y];
        v = Xt(E, v, S);
      }
      const b = a.fn({
        ...e,
        [f]: p,
        [u]: v
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - r
        }
      };
    }
  };
};
function j(t) {
  return Re(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function I(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function P(t) {
  var e;
  return (e = (Re(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Re(t) {
  return t instanceof Node || t instanceof I(t).Node;
}
function M(t) {
  return t instanceof Element || t instanceof I(t).Element;
}
function $(t) {
  return t instanceof HTMLElement || t instanceof I(t).HTMLElement;
}
function Qt(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof I(t).ShadowRoot;
}
function ut(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = R(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function sr(t) {
  return ["table", "td", "th"].includes(j(t));
}
function Pt(t) {
  const e = Vt(), n = R(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function ar(t) {
  let e = Z(t);
  for (; $(e) && !It(e); ) {
    if (Pt(e))
      return e;
    e = Z(e);
  }
  return null;
}
function Vt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function It(t) {
  return ["html", "body", "#document"].includes(j(t));
}
function R(t) {
  return I(t).getComputedStyle(t);
}
function Rt(t) {
  return M(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Z(t) {
  if (j(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Qt(t) && t.host || // Fallback.
    P(t)
  );
  return Qt(e) ? e.host : e;
}
function Fe(t) {
  const e = Z(t);
  return It(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : $(e) && ut(e) ? e : Fe(e);
}
function ot(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = Fe(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = I(i);
  return o ? e.concat(s, s.visualViewport || [], ut(i) ? i : [], s.frameElement && n ? ot(s.frameElement) : []) : e.concat(i, ot(i, [], n));
}
function De(t) {
  const e = R(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = $(t), o = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, a = wt(n) !== o || wt(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Bt(t) {
  return M(t) ? t : t.contextElement;
}
function Y(t) {
  const e = Bt(t);
  if (!$(e))
    return H(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = De(e);
  let s = (o ? wt(n.width) : n.width) / r, a = (o ? wt(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
var cr = /* @__PURE__ */ H(0);
function $e(t) {
  const e = I(t);
  return !Vt() || !e.visualViewport ? cr : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function lr(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== I(t) ? !1 : e;
}
function W(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), o = Bt(t);
  let s = H(1);
  e && (r ? M(r) && (s = Y(r)) : s = Y(t));
  const a = lr(o, n, r) ? $e(o) : H(0);
  let c = (i.left + a.x) / s.x, l = (i.top + a.y) / s.y, d = i.width / s.x, u = i.height / s.y;
  if (o) {
    const f = I(o), p = r && M(r) ? I(r) : r;
    let v = f.frameElement;
    for (; v && r && p !== f; ) {
      const b = Y(v), g = v.getBoundingClientRect(), y = R(v), E = g.left + (v.clientLeft + parseFloat(y.paddingLeft)) * b.x, S = g.top + (v.clientTop + parseFloat(y.paddingTop)) * b.y;
      c *= b.x, l *= b.y, d *= b.x, u *= b.y, c += E, l += S, v = I(v).frameElement;
    }
  }
  return Et({
    width: d,
    height: u,
    x: c,
    y: l
  });
}
function ur(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: r
  } = t;
  const i = $(n), o = P(n);
  if (n === o)
    return e;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = H(1);
  const c = H(0);
  if ((i || !i && r !== "fixed") && ((j(n) !== "body" || ut(o)) && (s = Rt(n)), $(n))) {
    const l = W(n);
    a = Y(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: e.width * a.x,
    height: e.height * a.y,
    x: e.x * a.x - s.scrollLeft * a.x + c.x,
    y: e.y * a.y - s.scrollTop * a.y + c.y
  };
}
function dr(t) {
  return Array.from(t.getClientRects());
}
function Ae(t) {
  return W(P(t)).left + Rt(t).scrollLeft;
}
function fr(t) {
  const e = P(t), n = Rt(t), r = t.ownerDocument.body, i = U(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = U(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Ae(t);
  const a = -n.scrollTop;
  return R(r).direction === "rtl" && (s += U(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function hr(t, e) {
  const n = I(t), r = P(t), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const l = Vt();
    (!l || l && e === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function pr(t, e) {
  const n = W(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = $(t) ? Y(t) : H(1), s = t.clientWidth * o.x, a = t.clientHeight * o.y, c = i * o.x, l = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: l
  };
}
function te(t, e, n) {
  let r;
  if (e === "viewport")
    r = hr(t, n);
  else if (e === "document")
    r = fr(P(t));
  else if (M(e))
    r = pr(e, n);
  else {
    const i = $e(t);
    r = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return Et(r);
}
function Me(t, e) {
  const n = Z(t);
  return n === e || !M(n) || It(n) ? !1 : R(n).position === "fixed" || Me(n, e);
}
function mr(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = ot(t, [], !1).filter((a) => M(a) && j(a) !== "body"), i = null;
  const o = R(t).position === "fixed";
  let s = o ? Z(t) : t;
  for (; M(s) && !It(s); ) {
    const a = R(s), c = Pt(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ut(s) && !c && Me(t, s)) ? r = r.filter((d) => d !== s) : i = a, s = Z(s);
  }
  return e.set(t, r), r;
}
function gr(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? mr(e, this._c) : [].concat(n), r], a = s[0], c = s.reduce((l, d) => {
    const u = te(e, d, i);
    return l.top = U(u.top, l.top), l.right = yt(u.right, l.right), l.bottom = yt(u.bottom, l.bottom), l.left = U(u.left, l.left), l;
  }, te(e, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function vr(t) {
  return De(t);
}
function br(t, e, n) {
  const r = $(e), i = P(e), o = n === "fixed", s = W(t, !0, o, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = H(0);
  if (r || !r && !o)
    if ((j(e) !== "body" || ut(i)) && (a = Rt(e)), r) {
      const l = W(e, !0, o, e);
      c.x = l.x + e.clientLeft, c.y = l.y + e.clientTop;
    } else i && (c.x = Ae(i));
  return {
    x: s.left + a.scrollLeft - c.x,
    y: s.top + a.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function ee(t, e) {
  return !$(t) || R(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Pe(t, e) {
  const n = I(t);
  if (!$(t))
    return n;
  let r = ee(t, e);
  for (; r && sr(r) && R(r).position === "static"; )
    r = ee(r, e);
  return r && (j(r) === "html" || j(r) === "body" && R(r).position === "static" && !Pt(r)) ? n : r || ar(t) || n;
}
var yr = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: r
  } = t;
  const i = this.getOffsetParent || Pe, o = this.getDimensions;
  return {
    reference: br(e, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function wr(t) {
  return R(t).direction === "rtl";
}
var xr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ur,
  getDocumentElement: P,
  getClippingRect: gr,
  getOffsetParent: Pe,
  getElementRects: yr,
  getClientRects: dr,
  getDimensions: vr,
  getScale: Y,
  isElement: M,
  isRTL: wr
};
function Er(t, e) {
  let n = null, r;
  const i = P(t);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const {
      left: l,
      top: d,
      width: u,
      height: f
    } = t.getBoundingClientRect();
    if (a || e(), !u || !f)
      return;
    const p = pt(d), v = pt(i.clientWidth - (l + u)), b = pt(i.clientHeight - (d + f)), g = pt(l), E = {
      rootMargin: -p + "px " + -v + "px " + -b + "px " + -g + "px",
      threshold: U(0, yt(1, c)) || 1
    };
    let S = !0;
    function N(x) {
      const m = x[0].intersectionRatio;
      if (m !== c) {
        if (!S)
          return s();
        m ? s(!1, m) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(N, {
        ...E,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(N, E);
    }
    n.observe(t);
  }
  return s(!0), o;
}
function Sr(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Bt(t), d = i || o ? [...l ? ot(l) : [], ...ot(e)] : [];
  d.forEach((y) => {
    i && y.addEventListener("scroll", n, {
      passive: !0
    }), o && y.addEventListener("resize", n);
  });
  const u = l && a ? Er(l, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((y) => {
    let [E] = y;
    E && E.target === l && p && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      p && p.observe(e);
    })), n();
  }), l && !c && p.observe(l), p.observe(e));
  let v, b = c ? W(t) : null;
  c && g();
  function g() {
    const y = W(t);
    b && (y.x !== b.x || y.y !== b.y || y.width !== b.width || y.height !== b.height) && n(), b = y, v = requestAnimationFrame(g);
  }
  return n(), () => {
    d.forEach((y) => {
      i && y.removeEventListener("scroll", n), o && y.removeEventListener("resize", n);
    }), u && u(), p && p.disconnect(), p = null, c && cancelAnimationFrame(v);
  };
}
var Tr = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: xr,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return er(t, e, {
    ...i,
    platform: o
  });
};
function Cr(t) {
  t.magic("anchor", (e) => {
    if (!e._x_anchor)
      throw "Alpine: No x-anchor directive found on element using $anchor...";
    return e._x_anchor;
  }), t.interceptClone((e, n) => {
    e && e._x_anchor && !n._x_anchor && (n._x_anchor = e._x_anchor);
  }), t.directive("anchor", t.skipDuringClone(
    (e, { expression: n, modifiers: r, value: i }, { cleanup: o, evaluate: s }) => {
      let { placement: a, offsetValue: c, unstyled: l } = re(r);
      e._x_anchor = t.reactive({ x: 0, y: 0 });
      let d = s(n);
      if (!d)
        throw "Alpine: no element provided to x-anchor...";
      let u = () => {
        let p;
        Tr(d, e, {
          placement: a,
          middleware: [nr(), or({ padding: 5 }), ir(c)]
        }).then(({ x: v, y: b }) => {
          l || ne(e, v, b), JSON.stringify({ x: v, y: b }) !== p && (e._x_anchor.x = v, e._x_anchor.y = b), p = JSON.stringify({ x: v, y: b });
        });
      }, f = Sr(d, e, () => u());
      o(() => f());
    },
    // When cloning (or "morphing"), we will graft the style and position data from the live tree...
    (e, { expression: n, modifiers: r, value: i }, { cleanup: o, evaluate: s }) => {
      let { unstyled: a } = re(r);
      e._x_anchor && (a || ne(e, e._x_anchor.x, e._x_anchor.y));
    }
  ));
}
function ne(t, e, n) {
  Object.assign(t.style, {
    left: e + "px",
    top: n + "px",
    position: "absolute"
  });
}
function re(t) {
  let n = ["top", "top-start", "top-end", "right", "right-start", "right-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end"].find((o) => t.includes(o)), r = 0;
  if (t.includes("offset")) {
    let o = t.findIndex((s) => s === "offset");
    r = t[o + 1] !== void 0 ? Number(t[o + 1]) : r;
  }
  let i = t.includes("no-style");
  return { placement: n, offsetValue: r, unstyled: i };
}
var Or = Cr;
function kr(t) {
  t.directive("collapse", e), e.inline = (n, { modifiers: r }) => {
    r.includes("min") && (n._x_doShow = () => {
    }, n._x_doHide = () => {
    });
  };
  function e(n, { modifiers: r }) {
    let i = ie(r, "duration", 250) / 1e3, o = ie(r, "min", 0), s = !r.includes("min");
    n._x_isShown || (n.style.height = `${o}px`), !n._x_isShown && s && (n.hidden = !0), n._x_isShown || (n.style.overflow = "hidden");
    let a = (l, d) => {
      let u = t.setStyles(l, d);
      return d.height ? () => {
      } : u;
    }, c = {
      transitionProperty: "height",
      transitionDuration: `${i}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    n._x_transition = {
      in(l = () => {
      }, d = () => {
      }) {
        s && (n.hidden = !1), s && (n.style.display = null);
        let u = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let f = n.getBoundingClientRect().height;
        u === f && (u = o), t.transition(n, t.setStyles, {
          during: c,
          start: { height: u + "px" },
          end: { height: f + "px" }
        }, () => n._x_isShown = !0, () => {
          Math.abs(n.getBoundingClientRect().height - f) < 1 && (n.style.overflow = null);
        });
      },
      out(l = () => {
      }, d = () => {
      }) {
        let u = n.getBoundingClientRect().height;
        t.transition(n, a, {
          during: c,
          start: { height: u + "px" },
          end: { height: o + "px" }
        }, () => n.style.overflow = "hidden", () => {
          n._x_isShown = !1, n.style.height == `${o}px` && s && (n.style.display = "none", n.hidden = !0);
        });
      }
    };
  }
}
function ie(t, e, n) {
  if (t.indexOf(e) === -1)
    return n;
  const r = t[t.indexOf(e) + 1];
  if (!r)
    return n;
  if (e === "duration") {
    let i = r.match(/([0-9]+)ms/);
    if (i)
      return i[1];
  }
  if (e === "min") {
    let i = r.match(/([0-9]+)px/);
    if (i)
      return i[1];
  }
  return r;
}
var Nr = kr, Ve = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], St = /* @__PURE__ */ Ve.join(","), Be = typeof Element > "u", K = Be ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, At = !Be && Element.prototype.getRootNode ? function(t) {
  return t.getRootNode();
} : function(t) {
  return t.ownerDocument;
}, He = function(e, n, r) {
  var i = Array.prototype.slice.apply(e.querySelectorAll(St));
  return n && K.call(e, St) && i.unshift(e), i = i.filter(r), i;
}, je = function t(e, n, r) {
  for (var i = [], o = Array.from(e); o.length; ) {
    var s = o.shift();
    if (s.tagName === "SLOT") {
      var a = s.assignedElements(), c = a.length ? a : s.children, l = t(c, !0, r);
      r.flatten ? i.push.apply(i, l) : i.push({
        scope: s,
        candidates: l
      });
    } else {
      var d = K.call(s, St);
      d && r.filter(s) && (n || !e.includes(s)) && i.push(s);
      var u = s.shadowRoot || // check for an undisclosed shadow
      typeof r.getShadowRoot == "function" && r.getShadowRoot(s), f = !r.shadowRootFilter || r.shadowRootFilter(s);
      if (u && f) {
        var p = t(u === !0 ? s.children : u.children, !0, r);
        r.flatten ? i.push.apply(i, p) : i.push({
          scope: s,
          candidates: p
        });
      } else
        o.unshift.apply(o, s.children);
    }
  }
  return i;
}, qe = function(e, n) {
  return e.tabIndex < 0 && (n || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || e.isContentEditable) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
}, Lr = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, Ue = function(e) {
  return e.tagName === "INPUT";
}, _r = function(e) {
  return Ue(e) && e.type === "hidden";
}, Ir = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Rr = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, Fr = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || At(e), r = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(e.name));
  else
    try {
      i = r(e.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var o = Rr(i, e.form);
  return !o || o === e;
}, Dr = function(e) {
  return Ue(e) && e.type === "radio";
}, $r = function(e) {
  return Dr(e) && !Fr(e);
}, oe = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, Ar = function(e, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var o = K.call(e, "details>summary:first-of-type"), s = o ? e.parentElement : e;
  if (K.call(s, "details:not([open]) *"))
    return !0;
  var a = At(e).host, c = a?.ownerDocument.contains(a) || e.ownerDocument.contains(e);
  if (!r || r === "full") {
    if (typeof i == "function") {
      for (var l = e; e; ) {
        var d = e.parentElement, u = At(e);
        if (d && !d.shadowRoot && i(d) === !0)
          return oe(e);
        e.assignedSlot ? e = e.assignedSlot : !d && u !== e.ownerDocument ? e = u.host : e = d;
      }
      e = l;
    }
    if (c)
      return !e.getClientRects().length;
  } else if (r === "non-zero-area")
    return oe(e);
  return !1;
}, Mr = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return K.call(n, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Tt = function(e, n) {
  return !(n.disabled || _r(n) || Ar(n, e) || // For a details element with a summary, the summary element gets the focus
  Ir(n) || Mr(n));
}, Mt = function(e, n) {
  return !($r(n) || qe(n) < 0 || !Tt(e, n));
}, Pr = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Vr = function t(e) {
  var n = [], r = [];
  return e.forEach(function(i, o) {
    var s = !!i.scope, a = s ? i.scope : i, c = qe(a, s), l = s ? t(i.candidates) : a;
    c === 0 ? s ? n.push.apply(n, l) : n.push(a) : r.push({
      documentOrder: o,
      tabIndex: c,
      item: i,
      isScope: s,
      content: l
    });
  }), r.sort(Lr).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, Br = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = je([e], n.includeContainer, {
    filter: Mt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Pr
  }) : r = He(e, n.includeContainer, Mt.bind(null, n)), Vr(r);
}, ze = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = je([e], n.includeContainer, {
    filter: Tt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = He(e, n.includeContainer, Tt.bind(null, n)), r;
}, mt = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return K.call(e, St) === !1 ? !1 : Mt(n, e);
}, Hr = /* @__PURE__ */ Ve.concat("iframe").join(","), vt = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return K.call(e, Hr) === !1 ? !1 : Tt(n, e);
};
function se(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ae(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? se(Object(n), !0).forEach(function(r) {
      jr(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : se(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function jr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var ce = /* @__PURE__ */ (function() {
  var t = [];
  return {
    activateTrap: function(n) {
      if (t.length > 0) {
        var r = t[t.length - 1];
        r !== n && r.pause();
      }
      var i = t.indexOf(n);
      i === -1 || t.splice(i, 1), t.push(n);
    },
    deactivateTrap: function(n) {
      var r = t.indexOf(n);
      r !== -1 && t.splice(r, 1), t.length > 0 && t[t.length - 1].unpause();
    }
  };
})(), qr = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Ur = function(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}, zr = function(e) {
  return e.key === "Tab" || e.keyCode === 9;
}, le = function(e) {
  return setTimeout(e, 0);
}, ue = function(e, n) {
  var r = -1;
  return e.every(function(i, o) {
    return n(i) ? (r = o, !1) : !0;
  }), r;
}, et = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return typeof e == "function" ? e.apply(void 0, r) : e;
}, gt = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, Wr = function(e, n) {
  var r = n?.document || document, i = ae({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0
  }, n), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  }, s, a = function(m, h, w) {
    return m && m[h] !== void 0 ? m[h] : i[w || h];
  }, c = function(m) {
    return o.containerGroups.findIndex(function(h) {
      var w = h.container, C = h.tabbableNodes;
      return w.contains(m) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      C.find(function(T) {
        return T === m;
      });
    });
  }, l = function(m) {
    var h = i[m];
    if (typeof h == "function") {
      for (var w = arguments.length, C = new Array(w > 1 ? w - 1 : 0), T = 1; T < w; T++)
        C[T - 1] = arguments[T];
      h = h.apply(void 0, C);
    }
    if (h === !0 && (h = void 0), !h) {
      if (h === void 0 || h === !1)
        return h;
      throw new Error("`".concat(m, "` was specified but was not a node, or did not return a node"));
    }
    var O = h;
    if (typeof h == "string" && (O = r.querySelector(h), !O))
      throw new Error("`".concat(m, "` as selector refers to no known node"));
    return O;
  }, d = function() {
    var m = l("initialFocus");
    if (m === !1)
      return !1;
    if (m === void 0)
      if (c(r.activeElement) >= 0)
        m = r.activeElement;
      else {
        var h = o.tabbableGroups[0], w = h && h.firstTabbableNode;
        m = w || l("fallbackFocus");
      }
    if (!m)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return m;
  }, u = function() {
    if (o.containerGroups = o.containers.map(function(m) {
      var h = Br(m, i.tabbableOptions), w = ze(m, i.tabbableOptions);
      return {
        container: m,
        tabbableNodes: h,
        focusableNodes: w,
        firstTabbableNode: h.length > 0 ? h[0] : null,
        lastTabbableNode: h.length > 0 ? h[h.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(T) {
          var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, L = w.findIndex(function(F) {
            return F === T;
          });
          if (!(L < 0))
            return O ? w.slice(L + 1).find(function(F) {
              return mt(F, i.tabbableOptions);
            }) : w.slice(0, L).reverse().find(function(F) {
              return mt(F, i.tabbableOptions);
            });
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(m) {
      return m.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !l("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
  }, f = function x(m) {
    if (m !== !1 && m !== r.activeElement) {
      if (!m || !m.focus) {
        x(d());
        return;
      }
      m.focus({
        preventScroll: !!i.preventScroll
      }), o.mostRecentlyFocusedNode = m, qr(m) && m.select();
    }
  }, p = function(m) {
    var h = l("setReturnFocus", m);
    return h || (h === !1 ? !1 : m);
  }, v = function(m) {
    var h = gt(m);
    if (!(c(h) >= 0)) {
      if (et(i.clickOutsideDeactivates, m)) {
        s.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: i.returnFocusOnDeactivate && !vt(h, i.tabbableOptions)
        });
        return;
      }
      et(i.allowOutsideClick, m) || m.preventDefault();
    }
  }, b = function(m) {
    var h = gt(m), w = c(h) >= 0;
    w || h instanceof Document ? w && (o.mostRecentlyFocusedNode = h) : (m.stopImmediatePropagation(), f(o.mostRecentlyFocusedNode || d()));
  }, g = function(m) {
    var h = gt(m);
    u();
    var w = null;
    if (o.tabbableGroups.length > 0) {
      var C = c(h), T = C >= 0 ? o.containerGroups[C] : void 0;
      if (C < 0)
        m.shiftKey ? w = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : w = o.tabbableGroups[0].firstTabbableNode;
      else if (m.shiftKey) {
        var O = ue(o.tabbableGroups, function(A) {
          var tt = A.firstTabbableNode;
          return h === tt;
        });
        if (O < 0 && (T.container === h || vt(h, i.tabbableOptions) && !mt(h, i.tabbableOptions) && !T.nextTabbableNode(h, !1)) && (O = C), O >= 0) {
          var L = O === 0 ? o.tabbableGroups.length - 1 : O - 1, F = o.tabbableGroups[L];
          w = F.lastTabbableNode;
        }
      } else {
        var D = ue(o.tabbableGroups, function(A) {
          var tt = A.lastTabbableNode;
          return h === tt;
        });
        if (D < 0 && (T.container === h || vt(h, i.tabbableOptions) && !mt(h, i.tabbableOptions) && !T.nextTabbableNode(h)) && (D = C), D >= 0) {
          var V = D === o.tabbableGroups.length - 1 ? 0 : D + 1, B = o.tabbableGroups[V];
          w = B.firstTabbableNode;
        }
      }
    } else
      w = l("fallbackFocus");
    w && (m.preventDefault(), f(w));
  }, y = function(m) {
    if (Ur(m) && et(i.escapeDeactivates, m) !== !1) {
      m.preventDefault(), s.deactivate();
      return;
    }
    if (zr(m)) {
      g(m);
      return;
    }
  }, E = function(m) {
    var h = gt(m);
    c(h) >= 0 || et(i.clickOutsideDeactivates, m) || et(i.allowOutsideClick, m) || (m.preventDefault(), m.stopImmediatePropagation());
  }, S = function() {
    if (o.active)
      return ce.activateTrap(s), o.delayInitialFocusTimer = i.delayInitialFocus ? le(function() {
        f(d());
      }) : f(d()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", v, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", v, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", E, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", y, {
        capture: !0,
        passive: !1
      }), s;
  }, N = function() {
    if (o.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", v, !0), r.removeEventListener("touchstart", v, !0), r.removeEventListener("click", E, !0), r.removeEventListener("keydown", y, !0), s;
  };
  return s = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(m) {
      if (o.active)
        return this;
      var h = a(m, "onActivate"), w = a(m, "onPostActivate"), C = a(m, "checkCanFocusTrap");
      C || u(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = r.activeElement, h && h();
      var T = function() {
        C && u(), S(), w && w();
      };
      return C ? (C(o.containers.concat()).then(T, T), this) : (T(), this);
    },
    deactivate: function(m) {
      if (!o.active)
        return this;
      var h = ae({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, m);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, N(), o.active = !1, o.paused = !1, ce.deactivateTrap(s);
      var w = a(h, "onDeactivate"), C = a(h, "onPostDeactivate"), T = a(h, "checkCanReturnFocus"), O = a(h, "returnFocus", "returnFocusOnDeactivate");
      w && w();
      var L = function() {
        le(function() {
          O && f(p(o.nodeFocusedBeforeActivation)), C && C();
        });
      };
      return O && T ? (T(p(o.nodeFocusedBeforeActivation)).then(L, L), this) : (L(), this);
    },
    pause: function() {
      return o.paused || !o.active ? this : (o.paused = !0, N(), this);
    },
    unpause: function() {
      return !o.paused || !o.active ? this : (o.paused = !1, u(), S(), this);
    },
    updateContainerElements: function(m) {
      var h = [].concat(m).filter(Boolean);
      return o.containers = h.map(function(w) {
        return typeof w == "string" ? r.querySelector(w) : w;
      }), o.active && u(), this;
    }
  }, s.updateContainerElements(e), s;
};
function Kr(t) {
  let e, n;
  window.addEventListener("focusin", () => {
    e = n, n = document.activeElement;
  }), t.magic("focus", (r) => {
    let i = r;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(o) {
        return i = o, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(o) {
        return vt(o);
      },
      previouslyFocused() {
        return e;
      },
      lastFocused() {
        return e;
      },
      focused() {
        return n;
      },
      focusables() {
        return Array.isArray(i) ? i : ze(i, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(o) {
        let s = this.all();
        return s[0] && s[0].isSameNode(o);
      },
      isLast(o) {
        let s = this.all();
        return s.length && s.slice(-1)[0].isSameNode(o);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let o = this.all(), s = document.activeElement;
        if (o.indexOf(s) !== -1)
          return this.__wrapAround && o.indexOf(s) === o.length - 1 ? o[0] : o[o.indexOf(s) + 1];
      },
      getPrevious() {
        let o = this.all(), s = document.activeElement;
        if (o.indexOf(s) !== -1)
          return this.__wrapAround && o.indexOf(s) === 0 ? o.slice(-1)[0] : o[o.indexOf(s) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(o) {
        o && setTimeout(() => {
          o.hasAttribute("tabindex") || o.setAttribute("tabindex", "0"), o.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), t.directive("trap", t.skipDuringClone(
    (r, { expression: i, modifiers: o }, { effect: s, evaluateLater: a, cleanup: c }) => {
      let l = a(i), d = !1, u = {
        escapeDeactivates: !1,
        allowOutsideClick: !0,
        fallbackFocus: () => r
      }, f = () => {
      };
      if (o.includes("noautofocus"))
        u.initialFocus = !1;
      else {
        let g = r.querySelector("[autofocus]");
        g && (u.initialFocus = g);
      }
      o.includes("inert") && (u.onPostActivate = () => {
        t.nextTick(() => {
          f = de(r);
        });
      });
      let p = Wr(r, u), v = () => {
      };
      const b = () => {
        f(), f = () => {
        }, v(), v = () => {
        }, p.deactivate({
          returnFocus: !o.includes("noreturn")
        });
      };
      s(() => l((g) => {
        d !== g && (g && !d && (o.includes("noscroll") && (v = Gr()), setTimeout(() => {
          p.activate();
        }, 15)), !g && d && b(), d = !!g);
      })), c(b);
    },
    // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (r, { expression: i, modifiers: o }, { evaluate: s }) => {
      o.includes("inert") && s(i) && de(r);
    }
  ));
}
function de(t) {
  let e = [];
  return We(t, (n) => {
    let r = n.hasAttribute("aria-hidden");
    n.setAttribute("aria-hidden", "true"), e.push(() => r || n.removeAttribute("aria-hidden"));
  }), () => {
    for (; e.length; )
      e.pop()();
  };
}
function We(t, e) {
  t.isSameNode(document.body) || !t.parentNode || Array.from(t.parentNode.children).forEach((n) => {
    n.isSameNode(t) ? We(t.parentNode, e) : e(n);
  });
}
function Gr() {
  let t = document.documentElement.style.overflow, e = document.documentElement.style.paddingRight, n = window.innerWidth - document.documentElement.clientWidth;
  return document.documentElement.style.overflow = "hidden", document.documentElement.style.paddingRight = `${n}px`, () => {
    document.documentElement.style.overflow = t, document.documentElement.style.paddingRight = e;
  };
}
var Jr = Kr;
function Yr(t) {
  t.directive("intersect", t.skipDuringClone((e, { value: n, expression: r, modifiers: i }, { evaluateLater: o, cleanup: s }) => {
    let a = o(r), c = {
      rootMargin: Qr(i),
      threshold: Xr(i)
    }, l = new IntersectionObserver((d) => {
      d.forEach((u) => {
        u.isIntersecting !== (n === "leave") && (a(), i.includes("once") && l.disconnect());
      });
    }, c);
    l.observe(e), s(() => {
      l.disconnect();
    });
  }));
}
function Xr(t) {
  if (t.includes("full"))
    return 0.99;
  if (t.includes("half"))
    return 0.5;
  if (!t.includes("threshold"))
    return 0;
  let e = t[t.indexOf("threshold") + 1];
  return e === "100" ? 1 : e === "0" ? 0 : +`.${e}`;
}
function Zr(t) {
  let e = t.match(/^(-?[0-9]+)(px|%)?$/);
  return e ? e[1] + (e[2] || "px") : void 0;
}
function Qr(t) {
  const e = "margin", n = "0px 0px 0px 0px", r = t.indexOf(e);
  if (r === -1)
    return n;
  let i = [];
  for (let o = 1; o < 5; o++)
    i.push(Zr(t[r + o] || ""));
  return i = i.filter((o) => o !== void 0), i.length ? i.join(" ").trim() : n;
}
var ti = Yr;
function Ht(t, e, n) {
  Ge();
  let r = Ke(n), i = typeof e == "string" ? ri(e) : e;
  return window.Alpine && window.Alpine.closestDataStack && !t._x_dataStack && (i._x_dataStack = window.Alpine.closestDataStack(t), i._x_dataStack && window.Alpine.cloneNode(t, i)), r.patch(t, i), t;
}
function ei(t, e, n, r = {}) {
  Ge();
  let i = Ke(r), o = t.parentNode, s = new st(t, e), a = typeof n == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", n), u;
  })() : n, c = document.createComment("[morph-start]"), l = document.createComment("[morph-end]");
  a.insertBefore(c, a.firstChild), a.appendChild(l);
  let d = new st(c, l);
  window.Alpine && window.Alpine.closestDataStack && (a._x_dataStack = window.Alpine.closestDataStack(o), a._x_dataStack && window.Alpine.cloneNode(o, a)), i.patchChildren(s, d);
}
function Ke(t = {}) {
  let e = (i) => i.getAttribute("key"), n = () => {
  }, r = {
    key: t.key || e,
    lookahead: t.lookahead || !1,
    updating: t.updating || n,
    updated: t.updated || n,
    removing: t.removing || n,
    removed: t.removed || n,
    adding: t.adding || n,
    added: t.added || n
  };
  return r.patch = function(i, o) {
    if (r.differentElementNamesTypesOrKeys(i, o))
      return r.swapElements(i, o);
    let s = !1, a = !1, c = (l) => r.skipUntilCondition = l;
    if (!ni(r.updating, () => a = !0, c, i, o, () => s = !0)) {
      if (i.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(i, o), i._x_teleport && o._x_teleport && r.patch(i._x_teleport, o._x_teleport)), ii(o)) {
        r.patchNodeValue(i, o), r.updated(i, o);
        return;
      }
      s || r.patchAttributes(i, o), r.updated(i, o), a || r.patchChildren(i, o);
    }
  }, r.differentElementNamesTypesOrKeys = function(i, o) {
    return i.nodeType != o.nodeType || i.nodeName != o.nodeName || r.getKey(i) != r.getKey(o);
  }, r.swapElements = function(i, o) {
    if (nt(r.removing, i))
      return;
    let s = o.cloneNode(!0);
    nt(r.adding, s) || (i.replaceWith(s), r.removed(i), r.added(s));
  }, r.patchNodeValue = function(i, o) {
    let s = o.nodeValue;
    i.nodeValue !== s && (i.nodeValue = s);
  }, r.patchAttributes = function(i, o) {
    if (i._x_transitioning || i._x_isShown && !o._x_isShown || !i._x_isShown && o._x_isShown)
      return;
    let s = Array.from(i.attributes), a = Array.from(o.attributes);
    for (let c = s.length - 1; c >= 0; c--) {
      let l = s[c].name;
      o.hasAttribute(l) || i.removeAttribute(l);
    }
    for (let c = a.length - 1; c >= 0; c--) {
      let l = a[c].name, d = a[c].value;
      i.getAttribute(l) !== d && i.setAttribute(l, d);
    }
  }, r.patchChildren = function(i, o) {
    let s = r.keyToMap(i.children), a = {}, c = he(o), l = he(i);
    for (; c; ) {
      oi(c, l);
      let u = r.getKey(c), f = r.getKey(l);
      if (r.skipUntilCondition) {
        let g = !l || r.skipUntilCondition(l), y = !c || r.skipUntilCondition(c);
        if (g && y)
          r.skipUntilCondition = null;
        else {
          g || (l = l && _(i, l)), y || (c = c && _(o, c));
          continue;
        }
      }
      if (!l)
        if (u && a[u]) {
          let g = a[u];
          i.appendChild(g), l = g, f = r.getKey(l);
        } else {
          if (!nt(r.adding, c)) {
            let g = c.cloneNode(!0);
            i.appendChild(g), r.added(g);
          }
          c = _(o, c);
          continue;
        }
      let p = (g) => g && g.nodeType === 8 && g.textContent === "[if BLOCK]><![endif]", v = (g) => g && g.nodeType === 8 && g.textContent === "[if ENDBLOCK]><![endif]";
      if (p(c) && p(l)) {
        let g = 0, y = l;
        for (; l; ) {
          let h = _(i, l);
          if (p(h))
            g++;
          else if (v(h) && g > 0)
            g--;
          else if (v(h) && g === 0) {
            l = h;
            break;
          }
          l = h;
        }
        let E = l;
        g = 0;
        let S = c;
        for (; c; ) {
          let h = _(o, c);
          if (p(h))
            g++;
          else if (v(h) && g > 0)
            g--;
          else if (v(h) && g === 0) {
            c = h;
            break;
          }
          c = h;
        }
        let N = c, x = new st(y, E), m = new st(S, N);
        r.patchChildren(x, m);
        continue;
      }
      if (l.nodeType === 1 && r.lookahead && !l.isEqualNode(c)) {
        let g = _(o, c), y = !1;
        for (; !y && g; )
          g.nodeType === 1 && l.isEqualNode(g) && (y = !0, l = r.addNodeBefore(i, c, l), f = r.getKey(l)), g = _(o, g);
      }
      if (u !== f) {
        if (!u && f) {
          a[f] = l, l = r.addNodeBefore(i, c, l), a[f].remove(), l = _(i, l), c = _(o, c);
          continue;
        }
        if (u && !f && s[u] && (l.replaceWith(s[u]), l = s[u], f = r.getKey(l)), u && f) {
          let g = s[u];
          if (g)
            a[f] = l, l.replaceWith(g), l = g, f = r.getKey(l);
          else {
            a[f] = l, l = r.addNodeBefore(i, c, l), a[f].remove(), l = _(i, l), c = _(o, c);
            continue;
          }
        }
      }
      let b = l && _(i, l);
      r.patch(l, c), c = c && _(o, c), l = b;
    }
    let d = [];
    for (; l; )
      nt(r.removing, l) || d.push(l), l = _(i, l);
    for (; d.length; ) {
      let u = d.shift();
      u.remove(), r.removed(u);
    }
  }, r.getKey = function(i) {
    return i && i.nodeType === 1 && r.key(i);
  }, r.keyToMap = function(i) {
    let o = {};
    for (let s of i) {
      let a = r.getKey(s);
      a && (o[a] = s);
    }
    return o;
  }, r.addNodeBefore = function(i, o, s) {
    if (!nt(r.adding, o)) {
      let a = o.cloneNode(!0);
      return i.insertBefore(a, s), r.added(a), a;
    }
    return o;
  }, r;
}
Ht.step = () => {
};
Ht.log = () => {
};
function nt(t, ...e) {
  let n = !1;
  return t(...e, () => n = !0), n;
}
function ni(t, e, n, ...r) {
  let i = !1;
  return t(...r, () => i = !0, e, n), i;
}
var fe = !1;
function ri(t) {
  const e = document.createElement("template");
  return e.innerHTML = t, e.content.firstElementChild;
}
function ii(t) {
  return t.nodeType === 3 || t.nodeType === 8;
}
var st = class {
  constructor(t, e) {
    this.startComment = t, this.endComment = e;
  }
  get children() {
    let t = [], e = this.startComment.nextSibling;
    for (; e && e !== this.endComment; )
      t.push(e), e = e.nextSibling;
    return t;
  }
  appendChild(t) {
    this.endComment.before(t);
  }
  get firstChild() {
    let t = this.startComment.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  nextNode(t) {
    let e = t.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  insertBefore(t, e) {
    return e.before(t), t;
  }
};
function he(t) {
  return t.firstChild;
}
function _(t, e) {
  let n;
  return t instanceof st ? n = t.nextNode(e) : n = e.nextSibling, n;
}
function Ge() {
  if (fe)
    return;
  fe = !0;
  let t = Element.prototype.setAttribute, e = document.createElement("div");
  Element.prototype.setAttribute = function(r, i) {
    if (!r.includes("@"))
      return t.call(this, r, i);
    e.innerHTML = `<span ${r}="${i}"></span>`;
    let o = e.firstElementChild.getAttributeNode(r);
    e.firstElementChild.removeAttributeNode(o), this.setAttributeNode(o);
  };
}
function oi(t, e) {
  let n = e && e._x_bindings && e._x_bindings.id;
  n && t.setAttribute && (t.setAttribute("id", n), t.id = n);
}
function si(t) {
  t.morph = Ht, t.morphBetween = ei;
}
var ai = si;
const ci = (t, e) => {
  let n;
  const r = /* @__PURE__ */ new Set();
  return function(i, o) {
    n && clearTimeout(n), i.forEach(({ target: s }) => r.add(s)), n = setTimeout(() => {
      t(r, o), n = null;
    }, e);
  };
}, li = (t) => {
  t.forEach((e) => ui(e)), t.clear();
}, ui = (t) => {
  const e = (l) => t.setAttribute("sizes", (l | 0) + "px");
  let n = 0, r = 0, i = t;
  for (; n < 100 && i; )
    n = i.offsetWidth, r = i.offsetHeight, i = i.parentNode;
  if (getComputedStyle(t).objectFit !== "cover")
    return e(n);
  const s = Number(t.getAttribute("width")) / Number(t.getAttribute("height"));
  if (!s || n / r >= s + 0.1)
    return e(n);
  const c = r * s;
  e(c);
}, q = new ResizeObserver(ci(li, 800)), pe = (t, e, n) => {
  if (e)
    return fi(t);
  if (n)
    return di(t, n);
  throw new TypeError("Invalid options");
}, di = (t, e) => (t = new URL(t, document.baseURI).href, t.includes("localhost") ? () => t : (n) => (e + t).replace("{width}", String(n))), fi = (t) => {
  if (t.includes("{width}"))
    return (e) => t.replaceAll("{width}", String(e));
  if (ge.test(t)) {
    const e = t.replace(ge, "_{width}x$1");
    return (n) => e.replaceAll("{width}", String(n));
  }
  return (e) => {
    const n = new URL(t, document.baseURI);
    return n.searchParams.set("width", String(e)), n.href;
  };
}, hi = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], me = (t, e = 1 / 0) => hi.filter((n) => n <= e).map((n) => `${t(n)} ${n}w`).join(","), ge = /_\d+x(\.jpg|\.png)/;
function pi(t) {
  const {
    autoSize: e = !0,
    shopify: n = !1,
    maxSize: r = 0,
    cloudURL: i = ""
  } = mi(t) ?? {};
  return (o) => {
    o.directive(
      "rias",
      (a, { expression: c }, { effect: l, evaluateLater: d, cleanup: u }) => {
        if (!(a instanceof HTMLImageElement))
          return console.warn("x-rias only works on img elements");
        if (u(() => q.unobserve(a)), !c)
          return e && q.observe(a);
        const f = d(c);
        l(() => {
          f((p) => {
            if (!p || typeof p != "string")
              return;
            const v = pe(p, n, i), b = r || Number(a.dataset.maxSize) || 1 / 0, g = v(Math.min(b, 360)), y = me(v, b);
            o.mutateDom(() => {
              a.src = g, a.srcset = y, a.loading = a.loading == "eager" ? "eager" : "lazy", (e || a.dataset.sizes == "auto") && q.observe(a);
            });
          });
        });
      }
    );
    const s = {
      srcset(a) {
        return me(
          pe(a, n, i),
          r || 1 / 0
        );
      },
      observe: q.observe.bind(q),
      unobserve: q.unobserve.bind(q)
    };
    o.magic("rias", () => s);
  };
}
const mi = (t) => {
  if (typeof t == "string")
    return { cloudURL: `https://res.cloudinary.com/${t}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof t == "object")
    return {
      ...t,
      cloudURL: t.key ? `https://res.cloudinary.com/${t.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
    };
}, gi = (t) => {
  t.addRootSelector(() => `[${t.prefixed("data-async")}]`);
  const e = "data-async", n = t.prefixed("ignore"), r = {}, i = /* @__PURE__ */ new WeakSet(), o = (s, { expression: a }, { evaluateLater: c, evaluate: l, cleanup: d }) => {
    i.has(s) || (i.add(s), c(a)(
      (u) => {
        if (typeof u != "object" || u === null)
          throw new Error(
            `alpine.js Async directive expected an object, but received: ${typeof u}`
          );
        [!0, void 0].includes(u) && (u = {});
        const f = t.reactive(u), p = t.addScopeToNode(s, f);
        f.init && l(f.init), d(() => {
          f.destroy && l(f.destroy), p();
        }), delete s._x_ignore, s.removeAttribute(n), t.initTree(s);
      },
      { scope: r }
    ));
  };
  o.inline = (s, { expression: a }) => {
    i.has(s) || (s._x_ignore = !0, s.setAttribute(n, ""));
  }, t.directive(e, o).before("ignore"), t.asyncData = (s, a) => {
    r[s] = async (...c) => {
      const [l, d] = a.split("?");
      try {
        const u = await import(l);
        if (d && d in u)
          return u[d](...c);
        if (s in u)
          return u[s](...c);
        if (u.default && typeof u.default == "function")
          return u.default(...c);
        if (typeof u == "function")
          return u(...c);
        throw new Error(
          `Async Data: Module ${a} does not export a function named ${s}, or a default function.`
        );
      } catch (u) {
        return console.error(
          "Async Data Loader Error while looking for:",
          s,
          a
        ), console.error(u), {};
      }
    };
  };
}, vi = (t) => {
  t.directive("clickable", (r, { expression: i }, { cleanup: o }) => {
    const s = r.querySelector(
      i || "a, button"
    );
    if (!s)
      return console.warn(
        `x-clickable: No target found for selector ${i || "a, button"}`
      );
    const a = function(c) {
      const l = c.target;
      !(l instanceof HTMLElement) || e(l, r) !== r || n(s, c.constructor, c);
    };
    o(
      t.bind(r, {
        "@click": a,
        "@auxclick": a
      })
    );
  });
  const e = (r, i) => t.findClosest(
    r,
    (o) => o.matches("a, button, input, select") || o === i
  ), n = (r, i = MouseEvent, o) => r.dispatchEvent(new i("click", o));
}, bi = (t) => {
  const e = /* @__PURE__ */ new Set(), n = t.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: "up",
    onScroll: (i) => (e.add(i), () => e.delete(i))
  });
  let r;
  n.onScroll((i) => {
    const o = i.current > i.previous ? "down" : "up";
    o !== n.direction ? r ??= setTimeout(
      () => n.direction = o,
      200
    ) : (clearTimeout(r), r = void 0);
  }), window.addEventListener(
    "scroll",
    () => {
      n.previous = n.current, n.current = window.scrollY, n.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : n.nearTop, e.forEach((i) => i(n));
    },
    { passive: !0 }
  ), t.$scroll = n, t.magic("scroll", () => n);
}, k = /* @__PURE__ */ Symbol("$slider"), Je = (t) => k in t, yi = {
  ":disabled"() {
    return this[k].isLast;
  },
  "x-on:click"() {
    this[k].next();
  }
}, wi = {
  ":disabled"() {
    return this[k].isFirst;
  },
  "x-on:click"() {
    this[k].prev();
  }
}, xi = (t) => ({
  ":disabled"() {
    return this[k].focusedIndex === t;
  },
  "x-on:click"() {
    this[k].scrollTo(t);
  }
}), Ei = {
  "x-on:mouseenter"() {
    this[k].pause();
  },
  "x-on:mouseleave"() {
    this[k].unpause();
  },
  "x-on:focusin"() {
    this[k].pause();
  },
  "x-on:focusout"() {
    this[k].unpause();
  }
}, Si = {
  ":style"() {
    const t = this[k].focusedSize;
    return {
      maxHeight: t ? `${t}px` : "max-content",
      transition: "max-height 300ms"
    };
  }
}, Ti = {
  "x-intersect.threshold.60"() {
    this[k].handleIntersect(this.$el);
  },
  "x-init"() {
    this[k].onLoad(this.$el);
  },
  "x-on:load"() {
    this[k].onLoad(this.$el);
  }
}, Ci = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, Oi = (t, e, n, { Alpine: r }) => {
  const i = r.$data(e);
  Je(i) ? i[k].components.set(t, e) : console.error(
    `Element with ${n.original} needs to be inside an x-slider element`,
    e
  );
}, G = (t) => Array.from(t.children).flatMap(
  (e) => getComputedStyle(e).display === "contents" ? G(e) : e
).filter(
  (e) => e.nodeName !== "TEMPLATE" && getComputedStyle(e).display !== "none"
), ki = (t) => t instanceof HTMLImageElement, Ni = (t, { expression: e }, { evaluate: n, cleanup: r, Alpine: i }) => {
  const o = [];
  r(() => o.forEach((c) => c()));
  const s = Object.assign(
    {
      scrollToDepth: 0,
      intoView: !1,
      centerVertically: !1,
      autoScroll: 0,
      autoInitialize: !1
    },
    e ? n(e) : {}
  ), a = i.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!s.autoInitialize,
    touched: !1,
    paused: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    init() {
      if (s.autoScroll) {
        const c = setInterval(() => {
          if (this.touched) return clearInterval(c);
          if (this.paused) return;
          const l = this.components.get("gallery");
          l && this.scrollTo(
            ln(
              this.focusedIndex + 1,
              G(l).length
            )
          );
        }, s.autoScroll);
        o.push(() => clearInterval(c));
      }
    },
    onLoad(c) {
      if (this.initialized || ki(c) && !c.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const l = this.components.get("gallery");
      l && (l.scrollLeft = 0), this.initialized = !0, this.init();
    },
    handleIntersect(c) {
      this.initialized && (this.focusedIndex = this.indexOfItem(c) ?? 0, this.focusedSize = c.clientHeight);
    },
    itemAtIndex(c) {
      const l = this.components.get("gallery");
      if (!l) return;
      const d = G(l);
      let u = d[sn(c, d.length - 1)];
      if (u !== void 0) {
        for (let f = 0; f < s.scrollToDepth; f++)
          u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(c + 1) : u;
      }
    },
    indexOfItem(c) {
      const l = this.components.get("gallery");
      if (!l) return;
      const d = G(l);
      for (let u = 0; u < d.length; u++)
        if (d[u].contains(c)) return u;
    },
    async scrollTo(c, l = 0, d = !1, u = !1) {
      const f = this.components.get("gallery");
      if (!f) return;
      const p = c instanceof Element ? c : this.itemAtIndex(c);
      if (!p) return;
      d && (this.touched = !0);
      const v = typeof c == "number" ? c : this.indexOfItem(p) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await cn()), u ? this.focusedIndex = v : this.focusedIndex += Math.sign(v - this.focusedIndex), window.scrollBy({
        top: 0.5
      }), window.scrollBy({
        top: -0.5
      }), s.intoView ? p.scrollIntoView({
        behavior: "smooth",
        block: s.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (f.style.scrollBehavior = "auto"), f.scrollLeft = c === 0 ? 0 : (qt(HTMLElement, p)?.offsetLeft ?? 0) - l, u && (f.style.scrollBehavior = null));
      const b = this.components.get("thumbnails");
      if (!b) return;
      const g = qt(HTMLElement, b.children[v]);
      g && b.scrollTo({
        top: g.offsetTop - (b.clientHeight - g.clientHeight) / 2,
        left: g.offsetLeft - (b.clientWidth - g.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    get isFirst() {
      return this.focusedIndex === 0;
    },
    get isLast() {
      const c = this.components.get("gallery");
      return c ? this.focusedIndex === G(c).length - 1 : !0;
    },
    get itemCount() {
      const c = this.components.get("gallery");
      return c ? G(c).length : 0;
    },
    next() {
      this.scrollTo(this.focusedIndex + 1);
    },
    prev() {
      this.scrollTo(this.focusedIndex - 1);
    }
  });
  i.addScopeToNode(t, { [k]: a }), s.autoInitialize && a.init();
}, Li = (t) => {
  t.addRootSelector(() => `[${t.prefixed("slider")}]`), t.directive("slider", (e, n, r) => {
    if (!n.value || n.value === "root")
      return Ni(e, n, r);
    (n.value === "gallery" || n.value === "thumbnails") && Oi(n.value, e, n, r);
  }), t.magic("slider", (e) => {
    const n = t.$data(e);
    if (Je(n)) return n[k];
  }), t.bind("$sliderDynamicHeight", Si), t.bind("$sliderItem", Ti), t.bind("$sliderNext", yi), t.bind("$sliderPrev", wi), t.bind("$sliderGoTo", xi), t.bind("$sliderPause", Ei), t.bind("$sliderUnfocusHidden", Ci);
}, ve = (t, e, n = e) => {
  const { scrollPaddingTop: r, scrollPaddingBottom: i } = window.getComputedStyle(t);
  return {
    top: be(r, e),
    bottom: be(i, n)
  };
}, be = (t, e) => t !== "auto" ? parseInt(t) : e, _i = 100, Ii = (t) => {
  t.addRootSelector(() => `[${t.prefixed("smartstick")}]`), t.directive("smartstick", (e, n, { cleanup: r }) => {
    let i = ve(e, _i);
    const o = t.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + i.top}px`;
      }
    });
    let s = 0, a = window.scrollY;
    const c = () => {
      const v = window.scrollY, b = v - a;
      o.top = Math.min(s, Math.max(0, o.top + b)), a = v;
    }, l = () => {
      i = ve(e, i.top, i.bottom), s = Math.max(
        0,
        e.clientHeight - window.innerHeight + i.top + i.bottom
      );
    }, d = new ResizeObserver(l);
    d.observe(e), window.addEventListener("resize", l);
    const u = window.matchMedia("(min-width: 1024px)"), f = (v) => window[v.matches ? "addEventListener" : "removeEventListener"](
      "scroll",
      c,
      { passive: !0 }
    );
    u.addEventListener("change", f), f(u);
    const p = t.effect(() => e.style.top = o.topString);
    r(() => {
      t.release(p), d.disconnect(), u.removeEventListener("change", f), window.removeEventListener("resize", l), window.removeEventListener("scroll", c);
    });
  });
}, jt = (t, e, n) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (i) => {
    const o = (s) => {
      const a = i.findClosest(s, r.has.bind(r));
      if (!a)
        return console.error(`Could not find root for ${t} component`, s);
      if (a instanceof HTMLElement)
        return r.get(a);
    };
    i.magic(t, (s) => o(s)), i.directive(t, (s, a, c) => {
      if (!a.value)
        return r.set(s, e(s, a, c));
      const l = o(s);
      if (!l)
        return Fi(t, s);
      (n?.[a.value] || Ri(t))(l, s, a, c);
    });
  };
}, Ri = (t) => (e, n, r) => {
  console.error(`Alpine ${t}: Invalid directive value`, n, r.original);
}, Fi = (t, e) => console.error(`Could not find root for ${t} component`, e), bt = /* @__PURE__ */ new WeakMap(), Di = (t, e) => {
  const n = e.findClosest(t, bt.has.bind(bt));
  if (n instanceof HTMLElement)
    return bt.get(n);
}, $i = (t, e, { Alpine: n, effect: r }) => {
  const i = n.reactive({
    active: null,
    id: 0,
    addAccordion(o) {
      const s = this.id++, a = n.reactive({
        active: o
      });
      return r(() => {
        a.active ? this.active = s : this.active === s && (this.active = null);
      }), r(() => {
        this.active === s ? a.active = !0 : a.active = !1;
      }), a;
    }
  });
  return bt.set(t, i), i;
}, Ai = (t) => t.directive("accordion-group", $i), Mi = (t, { modifiers: [e = "closed"] }, { Alpine: n }) => Di(t, n)?.addAccordion(e === "open") ?? n.reactive({
  active: e === "open"
}), Pi = {
  open: !0,
  close: !1,
  toggle: null
}, Vi = (t, e, { modifiers: [n = "toggle"] }, { Alpine: r }) => {
  r.bind(e, {
    "x-on:click": () => {
      t.active = Pi[n] ?? !t.active;
    },
    ":aria-expanded": () => t.active
  });
}, Bi = (t, e, n, { Alpine: r }) => {
  r.bind(e, {
    "x-show": () => t.active
  });
}, Hi = {
  control: Vi,
  container: Bi
}, ji = jt("accordion", Mi, Hi), qi = (t) => {
  Ai(t), ji(t);
}, ye = new ResizeObserver((t) => {
  for (const e of t) {
    const n = e.target;
    n instanceof HTMLElement && Ui(n);
  }
}), Ui = async (t) => {
  await Ct.nextTick(), t.scrollLeft = (t.scrollWidth - t.clientWidth) / 2, t.scrollTop = (t.scrollHeight - t.clientHeight) / 2;
}, we = Array.prototype.forEach, zi = (t) => t.directive("dragscroll", (e, { modifiers: n }, { cleanup: r }) => {
  const i = n.includes("center");
  r(Wi(e)), e.classList.add("overscroll-contain", "cursor-grab"), i && (we.call(e.children, (o) => ye.observe(o)), r(() => we.call(e.children, (o) => ye.unobserve(o))));
}), rt = (t) => {
  t.preventDefault(), t.stopPropagation();
}, xe = ["pointerup", "mouseup", "touchend"], Wi = (t) => {
  const e = (i) => {
    rt(i), t.scrollLeft -= i.movementX, t.scrollTop -= i.movementY;
  }, n = async (i) => {
    rt(i), document.removeEventListener("pointermove", e, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), t.classList.add("cursor-grab"), await Ct.nextTick(), document.removeEventListener("click", rt, !0), xe.forEach((o) => document.removeEventListener(o, n, {
      capture: !0
    }));
  }, r = (i) => {
    Ki(i) || i.button !== 2 && (rt(i), t.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", e, { capture: !0 }), xe.forEach((o) => document.addEventListener(o, n, {
      capture: !0
    })), document.addEventListener("click", rt, { capture: !0 }));
  };
  return t.addEventListener("pointerdown", r), () => t.removeEventListener("pointerdown", r);
}, Ki = (t) => t instanceof TouchEvent || t instanceof PointerEvent && t.pointerType === "touch", Gi = (t, e, { Alpine: n }) => {
  const r = n.reactive({
    root: t,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return n.bind(t, {
    "x-id": () => ["x-panel"]
  }), r;
}, Ji = jt("panel", Gi, {
  summary: (t, e, n, { Alpine: r }) => {
    r.bind(e, {
      ":aria-expanded": () => t.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (t, e, n, { Alpine: r }) => {
    r.bind(e, {
      "x-show": () => t.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), Yi = jt("tabs", (t, e, { Alpine: n, evaluate: r }) => n.reactive({
  activeTab: 0,
  isSelected(o) {
    return this.tabs[this.activeTab] === o;
  },
  tabs: [],
  panels: [],
  $focus: r("$focus")
}), {
  list: (t, e, n, { Alpine: r }) => {
    const i = () => t.$focus.wrap().next(), o = () => t.$focus.wrap().previous();
    r.bind(e, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": o,
      "@keydown.arrow-right.stop.prevent": i,
      "@keydown.arrow-up.stop.prevent": o,
      "@keydown.arrow-down.stop.prevent": i
    });
  },
  tab: (t, e, n, { Alpine: r }) => {
    const i = t.tabs.push(e) - 1;
    r.bind(e, {
      ":tabindex": () => +(i === t.activeTab) - 1,
      ":aria-selected": () => i === t.activeTab,
      "@click": () => t.$focus.focus(e),
      "@focus": () => t.activeTab = i
    });
  },
  panel: (t, e, n, { Alpine: r }) => {
    const i = t.panels.push(e) - 1;
    r.bind(e, {
      "x-show": () => i === t.activeTab,
      ":hidden": () => i !== t.activeTab,
      ":aria-hidden": () => i !== t.activeTab
    });
  }
});
var at;
(function(t) {
  t[t.None = 0] = "None", t[t.Left = 1] = "Left", t[t.Right = 2] = "Right", t[t.Up = 4] = "Up", t[t.Down = 8] = "Down";
})(at || (at = {}));
const ct = /* @__PURE__ */ new WeakMap(), Xi = ct.has.bind(ct), Zi = (t) => t.directive("swipe", (e, n, { cleanup: r }) => {
  const i = {
    dispatch: (o) => {
      const s = Object.entries(at).filter(([, a]) => typeof a == "number" && a && (o & a) === a).map(([a]) => a.toLowerCase());
      e.dispatchEvent(new CustomEvent("swipe", {
        detail: s.join("-")
      })), e.dispatchEvent(new CustomEvent(`swipe${s.join("")}`, {
        detail: s.join("-")
      }));
    }
  };
  ct.set(e, i), e.addEventListener("touchstart", Ee), r(() => e.removeEventListener("touchstart", Ee));
}), Ee = (t) => {
  const e = ct.get(t.currentTarget);
  if (!e)
    return;
  const n = t.touches[0], { clientX: r, clientY: i } = n;
  e.start ??= { x: r, y: i }, document.addEventListener("touchend", Qi, { once: !0 });
}, Qi = (t) => {
  const e = t.target;
  if (!e)
    return;
  const n = ct.get(Ye(e, Xi));
  if (!n?.start)
    return;
  const r = t.changedTouches[0], { clientX: i, clientY: o } = r, s = to(n.start, { x: i, y: o });
  s !== at.None && (n.dispatch(s), delete n.start);
}, Ye = (t, e) => e(t) ? t : t.parentElement ? Ye(t.parentElement, e) : null, to = (t, e) => {
  const n = [e.x - t.x, e.y - t.y];
  if (n.every((a) => Math.abs(a) < 50))
    return at.None;
  const r = Math.sqrt(n[0] * n[0] + n[1] * n[1]), [i, o] = n.map((a) => a / r);
  return Se(i) | Se(o) << 2;
}, Se = (t) => t > 0.5 ? 2 : t < -0.5 ? 1 : 0, eo = (t) => {
  t.magic("screen", () => (e) => {
    const n = typeof e == "number" ? e : ro[e] ?? Number(e);
    return n ? io(n, t).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(e)})`), !1);
  });
}, no = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, ro = no, Xe = {}, io = (t, e) => Xe[t] ?? oo(t, e), oo = (t, e) => {
  const n = window.matchMedia(`(min-width: ${t}px)`), r = e.reactive({
    value: n.matches
  });
  return Xe[t] = r, n.addEventListener("change", (i) => {
    r.value = i.matches;
  }), r;
}, so = (t) => t.plugin([eo]), ao = (t) => t.plugin([qi, zi, Ji, Zi, Yi, so]), co = (t) => {
  t.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, lo = (t) => {
  t.directive(
    "inert-trap",
    (e, { expression: n, modifiers: r }, { evaluateLater: i, effect: o }) => {
      const s = r.includes("retain"), a = r.includes("noscroll"), c = r.includes("return"), l = i(n), d = [];
      let u = null;
      o(() => {
        l((f) => {
          if (f) {
            u = document.activeElement;
            for (const p of uo(
              e,
              ...document.querySelectorAll("[role=alertdialog]"),
              s ? u?.closest("[data-retain-focus-from]") ?? u : null
            ))
              p.setAttribute("inert", "inert"), d.push(p);
            a && document.documentElement.style.setProperty("overflow", "hidden");
          } else {
            for (const p of d)
              p.removeAttribute("inert");
            d.length = 0, a && document.documentElement.style.removeProperty("overflow"), c && u && (u.focus(), u = null);
          }
        });
      });
    }
  );
};
function uo(...t) {
  return t = t.filter((n) => n !== null), document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_ELEMENT,
    (n) => {
      if (!(n instanceof HTMLElement) || n.matches("[inert] > *") || t.includes(n)) return NodeFilter.FILTER_REJECT;
      for (const r of t)
        if (n.contains(r)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }
  );
}
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let t = this.nextNode();
  for (; t; )
    yield t, t = this.nextNode();
};
const fo = (t) => {
  t.directive("highlight-scroll", (e, { expression: n }, { cleanup: r }) => {
    const i = n.trim();
    if (!i) {
      console.warn(
        "Alpine.js: v-highlight-scroll requires a class name to highlight."
      );
      return;
    }
    const o = e.firstChild;
    if (!o || !(o instanceof Text)) {
      console.warn(
        "Alpine.js: v-highlight-scroll requires a text node as the first child."
      );
      return;
    }
    const s = (o.textContent?.trim().split("") ?? []).map((l) => {
      const d = document.createElement("span");
      return d.textContent = l, d.classList.add(i), d;
    });
    o.replaceWith(...s);
    let a = -1;
    const c = setInterval(() => {
      a == -1 ? s.forEach((l) => l.classList.remove(i)) : s[a]?.classList.remove(i), a += 1, a %= s.length, s[a]?.classList.add(i);
    }, 500);
    r(() => clearInterval(c));
  }), t.addInitSelector(() => t.prefixed("highlight-scroll"));
}, ho = [
  Or,
  gi,
  vi,
  Nr,
  Jr,
  lo,
  ti,
  co,
  ai,
  pi({ shopify: !0, autoSize: !0 }),
  ao,
  fo,
  Li,
  Ii,
  bi,
  (t) => {
    t.magic("dataset", (e) => e.dataset), t.magic("formatMoney", () => J);
  }
], po = (t) => t.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible = !this.visible;
  }
}), mo = (t) => t.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), go = (t) => {
  t.store("search", {
    openState: !1,
    get isOpen() {
      return window.location.pathname !== "/search" && this.openState;
    },
    set isOpen(e) {
      this.openState = e;
    },
    query: "",
    get searchUrl() {
      const e = new URL("/search", window.location.origin);
      return e.search = new URLSearchParams({
        q: this.query,
        type: "product"
      }).toString(), e;
    }
  });
}, vo = [yn, po, mo, go];
Ct.plugin([...ho, ...vo, ...Wn]);
window.Alpine = Ct;
export {
  Ct as default
};
